var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Einstellungen"),
      confirmText: _vm.$gettext("Speichern"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "600",
      width: "500",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.storeSettings,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            !_vm.loadSettings
              ? _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c("fieldset", [
                      _c("legend", [
                        _vm._v(
                          _vm._s(_vm.$gettext("Allgemeine Einstellungen"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$gettext("Art der Inhaltsabfolge"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentProgression,
                                expression: "currentProgression",
                              },
                            ],
                            staticClass: "size-s",
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentProgression = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "0",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Frei")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "1",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Sequentiell")))]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$gettext(
                                "Editierberechtigung für Tutor/-innen"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentPermissionLevel,
                                expression: "currentPermissionLevel",
                              },
                            ],
                            staticClass: "size-s",
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentPermissionLevel = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "dozent",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "tutor",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("fieldset", [
                      _c("legend", [_vm._v(_vm._s(_vm.$gettext("Feedback")))]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$gettext(
                                "Am Ende eines Kapitels einen Dialog für die Bewertung anzeigen"
                              )
                            ) +
                            "\n                    "
                        ),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentShowFeedbackPopup,
                                expression: "currentShowFeedbackPopup",
                              },
                            ],
                            staticClass: "size-s",
                            on: {
                              change: function change($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.currentShowFeedbackPopup = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "0",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "option",
                              {
                                attrs: {
                                  value: "1",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$gettext("Bewertung auf der Seite anzeigen")
                              ) +
                              "\n                    "
                          ),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentShowFeedbackInContentbar,
                                  expression: "currentShowFeedbackInContentbar",
                                },
                              ],
                              staticClass: "size-s",
                              on: {
                                change: function change($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.currentShowFeedbackInContentbar = $event
                                    .target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "0",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "1",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.certificatesRemindersEnabled
                      ? _c(
                          "fieldset",
                          [
                            _c("legend", [
                              _vm._v(_vm._s(_vm.$gettext("Zertifikate"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.makeCert,
                                      expression: "makeCert",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.makeCert)
                                      ? _vm._i(_vm.makeCert, null) > -1
                                      : _vm.makeCert,
                                  },
                                  on: {
                                    change: function change($event) {
                                      var $$a = _vm.makeCert,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.makeCert = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.makeCert = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.makeCert = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Zertifikat bei Erreichen einer Fortschrittsgrenze versenden"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("studip-tooltip-icon", {
                                  attrs: {
                                    text: _vm.$gettext(
                                      "Erreicht eine Person in diesem Lernmaterial den " +
                                        "hier eingestellten Fortschritt, so erhält Sie ein PDF-Zertifikat per E-Mail."
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.makeCert
                              ? [
                                  _c("label", [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "Erforderlicher Fortschritt (in Prozent)"
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.certThreshold,
                                          expression: "certThreshold",
                                        },
                                      ],
                                      attrs: {
                                        type: "number",
                                        min: "1",
                                        max: "100",
                                      },
                                      domProps: {
                                        value: _vm.certThreshold,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.certThreshold =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext("Bild wählen")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("studip-tooltip-icon", {
                                        attrs: {
                                          text: _vm.$gettext(
                                            "Wählen Sie hier ein Bild, das auf " +
                                              "dem Zertifikat in der linken oberen Ecke in Originalgröße angezeigt wird. Wenn Sie das " +
                                              "Bild als Hintergrund des Zertifikats verwenden möchten, muss es nur die passende Größe " +
                                              "haben, um die ganze Seite auszufüllen."
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("courseware-file-chooser", {
                                        attrs: {
                                          isImage: true,
                                        },
                                        on: {
                                          selectFile: _vm.updateCertImage,
                                        },
                                        model: {
                                          value: _vm.certImage,
                                          callback: function callback($$v) {
                                            _vm.certImage = $$v
                                          },
                                          expression: "certImage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("label", [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$gettext("Titel")) +
                                          "\n                            "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.certTitle,
                                            expression: "certTitle",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                        },
                                        domProps: {
                                          value: _vm.certTitle,
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) return
                                            _vm.certTitle = $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "cert-text",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Text")) +
                                            "\n                        "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("studip-wysiwyg", {
                                    attrs: {
                                      id: "cert-text",
                                    },
                                    model: {
                                      value: _vm.certText,
                                      callback: function callback($$v) {
                                        _vm.certText = $$v
                                      },
                                      expression: "certText",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      attrs: {
                                        type: "button",
                                      },
                                      on: {
                                        click: function click($event) {
                                          $event.preventDefault()
                                          return _vm.previewCertificate.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$gettext("Vorschau")) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.certificatesRemindersEnabled
                      ? _c(
                          "fieldset",
                          [
                            _c("legend", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Erinnerungen")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sendReminders,
                                      expression: "sendReminders",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.sendReminders)
                                      ? _vm._i(_vm.sendReminders, null) > -1
                                      : _vm.sendReminders,
                                  },
                                  on: {
                                    change: function change($event) {
                                      var $$a = _vm.sendReminders,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.sendReminders = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.sendReminders = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.sendReminders = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Erinnerungsnachrichten an alle Teilnehmenden schicken"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("studip-tooltip-icon", {
                                  attrs: {
                                    text: _vm.$gettext(
                                      "Hier können periodisch Nachrichten an alle " +
                                        "Teilnehmenden verschickt werden, um z.B. an die Bearbeitung dieses Lernmaterials " +
                                        "zu erinnern."
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.sendReminders
                              ? [
                                  _c("label", [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "Zeitraum zwischen Erinnerungen"
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.reminderInterval,
                                            expression: "reminderInterval",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.reminderInterval = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "7",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("wöchentlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "14",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("14-tägig")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "30",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("monatlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "90",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "vierteljährlich"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "180",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("halbjährlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "365",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("jährlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-3",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Erstmalige Erinnerung am"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.reminderStartDate,
                                              expression: "reminderStartDate",
                                            },
                                          ],
                                          attrs: {
                                            type: "date",
                                          },
                                          domProps: {
                                            value: _vm.reminderStartDate,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.reminderStartDate =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-3",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Letztmalige Erinnerung am"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.reminderEndDate,
                                              expression: "reminderEndDate",
                                            },
                                          ],
                                          attrs: {
                                            type: "date",
                                          },
                                          domProps: {
                                            value: _vm.reminderEndDate,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.reminderEndDate =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "reminder-text",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Text der Erinnerungsmail"
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("studip-wysiwyg", {
                                    attrs: {
                                      id: "reminder-text",
                                    },
                                    model: {
                                      value: _vm.reminderMailText,
                                      callback: function callback($$v) {
                                        _vm.reminderMailText = $$v
                                      },
                                      expression: "reminderMailText",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.certificatesRemindersEnabled
                      ? _c(
                          "fieldset",
                          [
                            _c("legend", [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Fortschritt")) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "label",
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.resetProgress,
                                      expression: "resetProgress",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.resetProgress)
                                      ? _vm._i(_vm.resetProgress, null) > -1
                                      : _vm.resetProgress,
                                  },
                                  on: {
                                    change: function change($event) {
                                      var $$a = _vm.resetProgress,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.resetProgress = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.resetProgress = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.resetProgress = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Fortschritt periodisch auf 0 zurücksetzen"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("studip-tooltip-icon", {
                                  attrs: {
                                    text: _vm.$gettext(
                                      "Hier kann eingestellt werden, den Fortschritt " +
                                        "aller Teilnehmenden periodisch auf 0 zurückzusetzen."
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resetProgress
                              ? [
                                  _c("label", [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "Zeitraum zum Rücksetzen des Fortschritts"
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.resetProgressInterval,
                                            expression: "resetProgressInterval",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.resetProgressInterval = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "14",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("14-tägig")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "30",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("monatlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "90",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "vierteljährlich"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "180",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("halbjährlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "365",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$gettext("jährlich")
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-3",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Erstmaliges Zurücksetzen am"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.resetProgressStartDate,
                                              expression:
                                                "resetProgressStartDate",
                                            },
                                          ],
                                          attrs: {
                                            type: "date",
                                          },
                                          domProps: {
                                            value: _vm.resetProgressStartDate,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.resetProgressStartDate =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-3",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Letztmaliges Zurücksetzen am"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.resetProgressEndDate,
                                              expression:
                                                "resetProgressEndDate",
                                            },
                                          ],
                                          attrs: {
                                            type: "date",
                                          },
                                          domProps: {
                                            value: _vm.resetProgressEndDate,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.resetProgressEndDate =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "reset-text",
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Text der Rücksetzungsmail"
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("studip-wysiwyg", {
                                    attrs: {
                                      id: "reset-text",
                                    },
                                    model: {
                                      value: _vm.resetProgressMailText,
                                      callback: function callback($$v) {
                                        _vm.resetProgressMailText = $$v
                                      },
                                      expression: "resetProgressMailText",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              : _c("studip-progress-indicator", {
                  attrs: {
                    description: _vm.$gettext("Lade Einstellungen…"),
                  },
                }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }